import {ListVerificationRequests} from './list-verification-requests';

export default ListVerificationRequests;